(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-buy-box"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getVideoEmbedUrl(url) {
      var ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]{11})/);
      if (ytMatch) return 'https://www.youtube.com/embed/' + ytMatch[1] + '?autoplay=1&rel=0';
      var vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
      if (vimeoMatch) return 'https://player.vimeo.com/video/' + vimeoMatch[1] + '?autoplay=1';
      return null;
    }

    function initBuyBox(sectionId) {
      var section = document.getElementById('section-' + sectionId);
      if (!section) return;

      // --- Gallery (init each instance independently) ---
      section.querySelectorAll('[data-cbbox-gallery]').forEach(function (gallery) {
        var thumbs = gallery.querySelectorAll('[data-cbbox-thumb]');
        var slides = gallery.querySelectorAll('[data-cbbox-slide]');

        thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            var idx = thumb.getAttribute('data-cbbox-thumb');
            thumbs.forEach(function (t) { t.classList.remove('is-active'); });
            slides.forEach(function (s) { s.classList.remove('is-active'); });
            thumb.classList.add('is-active');
            var target = gallery.querySelector('[data-cbbox-slide="' + idx + '"]');
            if (target) target.classList.add('is-active');
          });
        });
      });

      // --- Plan selection (shared handler) ---
      var plansContainer = document.getElementById('cbbox-plans-' + sectionId);
      var oneTimePanel = document.getElementById('cbbox-one-time-panel-' + sectionId);
      var variantInput = document.getElementById('cbbox-variant-' + sectionId);
      var sellingPlanInput = document.getElementById('cbbox-selling-plan-' + sectionId);
      var ctaLabel = document.getElementById('cbbox-cta-label-' + sectionId);
      var ctaBaseText = ctaLabel ? ctaLabel.textContent.trim().split(/\s{2,}/)[0].trim() : 'Add to Cart';
      var formQtyInput = section.querySelector('input[name="quantity"]');
      var currentQty = 1;

      function refreshCtaPrice(priceLabel) {
        if (!ctaLabel) return;
        if (!priceLabel) { ctaLabel.innerHTML = ctaBaseText; return; }
        ctaLabel.innerHTML = ctaBaseText + '&nbsp;&nbsp;' + priceLabel;
      }

      function handleRadioChange(radio) {
        var sectionEl = document.getElementById('section-' + sectionId);
        sectionEl.querySelectorAll('.custom-buy-box__plan').forEach(function (plan) {
          plan.classList.remove('is-selected');
        });
        var parentLabel = radio.closest('.custom-buy-box__plan');
        if (parentLabel) parentLabel.classList.add('is-selected');
        if (variantInput && radio.value) variantInput.value = radio.value;
        currentQty = parseInt(radio.getAttribute('data-quantity'), 10) || 1;
        if (formQtyInput) formQtyInput.value = currentQty;
        refreshCtaPrice(radio.getAttribute('data-price-label'));
        // Attach selling plan for subscriptions; clear for one-time / bundle
        if (sellingPlanInput) {
          sellingPlanInput.value = radio.getAttribute('data-selling-plan') || '';
          if (sellingPlanInput.value === '') {
            console.warn('[BuyBox] No selling plan ID on this plan block. It will add as one-time. Fix this in the theme editor.');
          }
        }
        updateFreeShipping();
      }

      function updateFreeShipping() {
        var badge = document.getElementById('cbbox-free-shipping-' + sectionId);
        if (!badge) return;
        var activeMode = 'subscribe';
        if (toggleContainer) {
          var activeBtn = toggleContainer.querySelector('.cbbox-toggle-btn.is-active');
          if (activeBtn) activeMode = activeBtn.getAttribute('data-cbbox-mode');
        }
        if (activeMode === 'subscribe') {
          badge.style.display = '';
        } else {
          var checkedOtRadio = oneTimePanel ? oneTimePanel.querySelector('.custom-buy-box__plan-radio:checked') : null;
          badge.style.display = (checkedOtRadio && checkedOtRadio.getAttribute('data-one-time-free-shipping') === 'true') ? '' : 'none';
        }
      }

      if (plansContainer) {
        plansContainer.querySelectorAll('.custom-buy-box__plan-radio').forEach(function (radio) {
          radio.addEventListener('change', function () { handleRadioChange(radio); });
        });
      }
      if (oneTimePanel) {
        oneTimePanel.querySelectorAll('.custom-buy-box__plan-radio').forEach(function (radio) {
          radio.addEventListener('change', function () { handleRadioChange(radio); });
        });
      }

      // --- Purchase type toggle ---
      var toggleContainer = document.getElementById('cbbox-toggle-' + sectionId);
      var subscribePanel = document.getElementById('cbbox-subscribe-panel-' + sectionId);

      if (toggleContainer) {
        var toggleBtns = toggleContainer.querySelectorAll('.cbbox-toggle-btn');

        toggleBtns.forEach(function (btn) {
          btn.addEventListener('click', function () {
            var mode = btn.getAttribute('data-cbbox-mode');
            toggleBtns.forEach(function (b) {
              b.classList.remove('is-active');
              b.setAttribute('aria-selected', 'false');
            });
            btn.classList.add('is-active');
            btn.setAttribute('aria-selected', 'true');

            if (mode === 'subscribe') {
              if (subscribePanel) subscribePanel.classList.add('is-active');
              if (oneTimePanel) oneTimePanel.classList.remove('is-active');
              var firstSubRadio = plansContainer
                ? plansContainer.querySelector('.custom-buy-box__plan-radio')
                : null;
              if (firstSubRadio) { firstSubRadio.checked = true; handleRadioChange(firstSubRadio); }
            } else {
              if (subscribePanel) subscribePanel.classList.remove('is-active');
              if (oneTimePanel) oneTimePanel.classList.add('is-active');
              var oneTimeRadio = oneTimePanel
                ? oneTimePanel.querySelector('.custom-buy-box__plan-radio')
                : null;
              if (oneTimeRadio) { oneTimeRadio.checked = true; handleRadioChange(oneTimeRadio); }
            }
          });
        });
      }

      // --- Form submit guard ---
      var form = section.querySelector('.custom-buy-box__form');
      var spErrorEl = document.getElementById('cbbox-sp-error-' + sectionId);
      if (form && spErrorEl) {
        form.addEventListener('submit', function (e) {
          if (subscribePanel && subscribePanel.classList.contains('is-active') && sellingPlanInput && sellingPlanInput.value === '') {
            e.preventDefault();
            spErrorEl.style.display = 'block';
          } else {
            spErrorEl.style.display = 'none';
          }
        });
      }

      // --- Mobile carousel ---
      section.querySelectorAll('[data-cbbox-carousel]').forEach(function (wrap) {
        var track = wrap.querySelector('.cbbox-carousel__track');
        var dots = wrap.querySelectorAll('[data-cbbox-dot]');
        if (!track) return;

        var slides = track.querySelectorAll('.cbbox-carousel__slide');
        if (slides.length <= 1) return;

        var current = 0;
        var intervalSec = parseInt(wrap.getAttribute('data-cbbox-interval'), 10) || 4;
        var intervalMs = intervalSec * 1000;
        var timer = null;

        function goTo(idx) {
          if (idx >= slides.length) idx = 0;
          if (idx < 0) idx = slides.length - 1;
          current = idx;
          track.style.transform = 'translateX(-' + (current * 100) + '%)';
          dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === current);
          });
        }

        function startTimer() {
          clearInterval(timer);
          timer = setInterval(function () { goTo(current + 1); }, intervalMs);
        }

        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            goTo(parseInt(dot.getAttribute('data-cbbox-dot'), 10));
            startTimer();
          });
        });

        var touchStartX = 0;
        wrap.addEventListener('touchstart', function (e) {
          touchStartX = e.touches[0].clientX;
          clearInterval(timer);
        }, { passive: true });
        wrap.addEventListener('touchend', function (e) {
          var diff = touchStartX - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
          startTimer();
        }, { passive: true });

        wrap.addEventListener('mouseenter', function () { clearInterval(timer); });
        wrap.addEventListener('mouseleave', startTimer);

        goTo(0);
        startTimer();
      });

      // --- Video testimonials ---
      section.querySelectorAll('[data-cbbox-video-wrap]').forEach(function (wrap) {
        var btn = wrap.querySelector('.cbbox-testimonial__play-btn');
        if (!btn) return;

        btn.addEventListener('click', function () {
          var url = btn.getAttribute('data-video-url');
          var embedUrl = getVideoEmbedUrl(url);

          if (embedUrl) {
            var iframe = document.createElement('iframe');
            iframe.src = embedUrl;
            iframe.setAttribute('allow', 'autoplay; fullscreen');
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('frameborder', '0');
            wrap.appendChild(iframe);
          } else {
            var video = document.createElement('video');
            video.src = url;
            video.controls = true;
            video.autoplay = true;
            video.playsInline = true;
            video.volume = 0.5;
            wrap.appendChild(video);
          }

          btn.style.display = 'none';
          var thumb = wrap.querySelector('.cbbox-testimonial__thumb');
          if (thumb) thumb.style.opacity = '0';
        });
      });

      // --- Gallery media grid videos ---
      section.querySelectorAll('[data-cbbox-gallery-video]').forEach(function (wrap) {
        var btn = wrap.querySelector('.cbbox-gallery-cell__play-btn');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var url = btn.getAttribute('data-video-url');
          var embedUrl = getVideoEmbedUrl(url);
          if (embedUrl) {
            var iframe = document.createElement('iframe');
            iframe.src = embedUrl;
            iframe.setAttribute('allow', 'autoplay; fullscreen');
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('frameborder', '0');
            wrap.appendChild(iframe);
          } else {
            var video = document.createElement('video');
            video.src = url;
            video.controls = true;
            video.autoplay = true;
            video.playsInline = true;
            video.volume = 0.5;
            wrap.appendChild(video);
          }
          btn.style.display = 'none';
          var poster = wrap.querySelector('.cbbox-gallery-cell__poster');
          if (poster) poster.style.opacity = '0';
        });
      });

      // --- Accordion ---
      var accordion = section.querySelector('.cbbox-accordion');
      if (accordion) {
        accordion.querySelectorAll('.cbbox-accordion__trigger').forEach(function (trigger) {
          trigger.addEventListener('click', function () {
            var isOpen = trigger.getAttribute('aria-expanded') === 'true';
            var panelId = trigger.getAttribute('aria-controls');
            var panel = document.getElementById(panelId);
            trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
            if (panel) panel.classList.toggle('is-open', !isOpen);
          });
        });
      }

      updateFreeShipping();
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.custom-buy-box').forEach(function (el) {
        var id = el.id.replace('section-', '');
        initBuyBox(id);
      });
    });

    // Reinitialise when the theme editor reloads a section
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector('.custom-buy-box')) {
        var id = e.target.querySelector('.custom-buy-box').id.replace('section-', '');
        initBuyBox(id);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
